<template>
  <div class="dropdown">
    <div
      class="dropdown-trigger"
      @click.prevent="isOpen = !isOpen"
    >
      <slot name="trigger"></slot>
    </div>
    <div
      class="absolute z-50 w-full md:w-64 bg-gray-200"
      v-show="isOpen"
    >
      <label
        class="block py-2 px-3 text-jblue-primary text-sm bg-gray-200 cursor-pointer hover:bg-gray-300"
        v-for="(item, index) in options"
        :key="index"
        :for="index"
        @click.self="isOpen = !isOpen"
      >
        <input
          @click="select(item)"
          type="radio"
          class="hidden cursor-pointer"
          :id="index"
          :value="item"
          v-model="search"
        >
        {{ $t(`messages.general.${item.translate}`) }}
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: "Vdropdown",
  data() {
    return {
      isOpen: false,
      search: "",
      options: [
        {
          title: "Ultima modificación de perfil",
          id: "1",
          translate: "last_modification"
        },
        { title: "Ultima conexión", id: "2", translate: "last_connection" },
        {
          title: "Fecha de creación de perfil",
          id: "3",
          translate: "profile_creation"
        }
      ]
    };
  },
  watch: {
    isOpen(isOpen) {
      if (isOpen) {
        document.addEventListener("click", this.closeDropdown);
      }
    }
  },
  methods: {
    closeDropdown() {
      if (!event.target.closest(".dropdown")) {
        this.isOpen = false;
      }
    },
    select(item) {
      this.$emit("onCloseDropdown", item);
    }
  }
};
</script>
